import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { FamilyRequest } from "../../../../orchestrator-api-client";

export const submitFamilyReducer = (
  state: CustomerState,
  action: PayloadAction<FamilyRequest>,
) => {
  state.family.householdMembers = action.payload.householdMembers!; // TODO: Must be set as non-nullable on swagger
  state.family.peopleWithIncome = action.payload.peopleWithIncome!; // TODO: Must be set as non-nullable on swagger
};
